import React, { useEffect, useState } from "react";
import { Dialog, DialogContent } from "@material-ui/core";
import { Tabs, Tab } from "@material-ui/core";
import { pDialogTab, pStatus } from "../../utils/parameters";
import { LoadingDialog } from "./LoadingDialog";
import { useDataProvider } from "../../api/DataProvider";
import SendIcon from "@mui/icons-material/Send";
import Button from "@mui/material/Button";
import Paper from "@mui/material/Paper";
import { useHistory } from "react-router-dom";
import { useVideo } from "../../api/VideoProvider";
import DialogHeader from "../signDialog_content_views/DialogHeader";
import DialogSignsStepper from "../signDialog_content_views/DialogSignsStepper";
import DialogContentMore from "../signDialog_content_views/DialogContentMore";
import DialogContentSendFeedback from "../signDialog_content_views/DialogContentSendFeedback";
import DialogContentSelectManual from "../signDialog_content_views/DialogContentSelectManual";
import DialogContentDef from "../signDialog_content_views/DialogContentDef";
import DialogContentSign from "../signDialog_content_views/DialogContentSign";
import DialogContentExamples from "../signDialog_content_views/DialogContentExamples";
import { pVisualControl, pVisualizerControl } from '../../utils/parameters';
import { useTranslation } from "react-i18next";
import { Accordion, AccordionSummary, AccordionDetails, Typography } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

import "../../styles/devices/mob_SignDialog.css";

export function SignDialog(props) {
  const { dialogElements, setDialogElements, openDialog, setOpenDialog, loading, sendFeedback2Server, setFeedback, prevDialogPosition, setPrevDialogPosition, teamTask, switchVisualControl, setVisualControlAction, visualControlAction, noCenterDialog, predictionFS } = props;
  const { t } = useTranslation("global")

  const [tabValue, setTabValue] = useState(null);
  const { setFaceStatus } = useVideo();
  const [ isAdmin, setIsAdmin ] = useState(null); 
  const [ isTask, setIsTask ] = useState(false); 

  /* Signs */
  const [dialogPosition, setDialogPosition] = useState({});
  const { genEntryByLemma, getLemmaByGloss, json_data_lemma, json_data_meaning, json_data_glosses } = useDataProvider();
  const [arr_history, setArr_history] = useState([]);
  const [activeStep, setActiveStep] = useState(0);

  const [moveLeftVisualControl, setMoveLeftVisualControl] = useState('0%') 
  const [expanded, setExpanded] = useState(false);

  const handleChange = () => {
    setExpanded(!expanded);
  };

  useEffect(() => {
    // console.log("🚀 ~ file: SignDialog.js:37 ~ SignDialog ~ teamTask:", teamTask)
    if (teamTask === undefined || teamTask['isAdmin'] === undefined) {
      setIsAdmin(false);
      setIsTask(false)
    } else {
      setIsAdmin(teamTask['isAdmin']);
      setIsTask(true)
    }

  }, [teamTask]);


  useEffect(() => {
    // console.log('dialog - switchVisualControl: '+switchVisualControl)

    if (noCenterDialog === true){
        setMoveLeftVisualControl('-60%')
    }else{
        setMoveLeftVisualControl('0%')
    }
    

}, [switchVisualControl])
  

  /* Update first time */
  useEffect(() => {
    try {
      if (prevDialogPosition === undefined) {    // preDialogPosition is undefined when the dialog is opened without a specific dialogPosition
        setDialogPosition(obtain_init_dialogPosition(dialogElements["elements"][0]));
      }else{
        if (tabValue !== pDialogTab.def) {
          setTabValue(pDialogTab.sign);
        }
        setDialogPosition(prevDialogPosition)
      }
    } catch {}
  }, [openDialog, loading, prevDialogPosition]);


  function obtain_init_dialogPosition(entry_idx, dialogElements_in = dialogElements) {

    setDialogElements(dialogElements_in);
    if (tabValue !== pDialogTab.def) {
      setTabValue(pDialogTab.sign);
    }
    setActiveStep(0);
    let initial_position_lemma = entry_idx;
    let initial_position_meaning = dialogElements_in[initial_position_lemma][0];
    let initial_position_gloss = dialogElements_in[initial_position_meaning][0];

    return {
      lemma: initial_position_lemma,
      meaning: initial_position_meaning,
      gloss: initial_position_gloss
    }

  }

  /* Close dialog */
  function handleClickClose() {
    /* Dialog settings */
    setOpenDialog(false);
    setTabValue(pDialogTab.sign);
    setArr_history([]);
    setPrevDialogPosition(undefined);
    setFaceStatus(pStatus.init);
  }

  /* NAVEGATION BETWEEN LEMMAS - USE OF HISTORY*/
  // /* Handle stepper click */
  function handleClickStep(lemma_idx, gloss_idx) {

    // console.log('HANDLE CLICK STEP')

    if (lemma_idx === pDialogTab.none) {
      setTabValue(pDialogTab.none);
    } else {

      setDialogPosition(
        {
          'lemma': lemma_idx,
          'meaning': Object.keys(dialogElements).find(key => dialogElements[key].includes(gloss_idx)),
          'gloss': gloss_idx
        }
      );
    }
  }

  const handleClickChangeLemma = (value) => () => {
    if (value !== dialogPosition["lemma"]) {
      addNewEntryHistory();
      let dialog_elements = genEntryByLemma([value]);
      setDialogPosition(obtain_init_dialogPosition(dialog_elements["elements"][0], dialog_elements));
    }
  };

  const handleClickChangeLemmaByGloss = (value) => () => {
    if (value !== dialogPosition["gloss"]) {
      addNewEntryHistory();
      const lemma_id = getLemmaByGloss(value);
      const dialog_elements_obtained = genEntryByLemma([lemma_id]);

      setDialogElements(dialog_elements_obtained);
      setDialogPosition(obtain_init_dialogPosition(dialog_elements_obtained["elements"][0], dialog_elements_obtained));
      setTabValue(pDialogTab.sign);
    }
  };



  function addNewEntryHistory() {
    arr_history.push(dialogElements);
    setArr_history(arr_history);
  }

  function returnLastEntryHistory() {
    const dialog_elements = arr_history.pop();
    setArr_history(arr_history);
    setDialogPosition(obtain_init_dialogPosition(dialog_elements["elements"][0], dialog_elements));
  }

  /* REPORT - FEEDBACK */
  const handleClickManualSelectionLemmaManual = (event) => {
    addNewEntryHistory();
    let dialog_elements = genEntryByLemma([event.target.value]);
    setDialogPosition(obtain_init_dialogPosition(dialog_elements["elements"][0], dialog_elements))
  };

  const handleClickStartSendFeedback = () => {
    const feedback = dialogPosition;
    setFeedback(feedback);
    setTabValue(pDialogTab.feedback);
  };

  const handleClickConfirmSendFeedback = () => {

    const data = {'lemma': dialogPosition["lemma"], 'meaning': dialogPosition["meaning"], 'gloss': dialogPosition["gloss"]};
    const data_labels = {
      'lemma': json_data_lemma[dialogPosition["lemma"]]['label'],
      'meaning': json_data_meaning[dialogPosition["meaning"]]['label'],
      'gloss': json_data_glosses[dialogPosition["gloss"]]['label'],
    }
    
    sendFeedback2Server(data, data_labels);
    handleClickClose();
  };

  const handleClickCancelSendFeedback = () => {
    setTabValue(pDialogTab.sign);
  };

  /* LINKING: HOME & SEARCH sections and COLLABORATION section */
  const history = useHistory();
  const handlePushScreenCollaborator = () => {

    if (teamTask==undefined){
      history.push({
        pathname: "/recorder",
        lemma: dialogPosition["lemma"],
        meaning: dialogPosition["meaning"],
        gloss: dialogPosition["gloss"],
      });
    }else{
      history.push({
        pathname: "/recorderTask",
        team_id : teamTask['team_id'],
        task_id : teamTask['task_id'],
        lemma: dialogPosition["lemma"],
        meaning: dialogPosition["meaning"],
        gloss: dialogPosition["gloss"],
      });
    }
  };


  useEffect(() => {
    //autoAction_label == "Grabar"
    // console.log('visualControlAction option: '+visualControlAction)
    switch (visualControlAction) {
        case pVisualizerControl.Btn_Signo_Definicion.id_action:
        case pVisualControl.Btn_Signo_Definicion.id_action:
            const tabValueNew = (tabValue === 0 ? 1 : 0);
            setTabValue(tabValueNew)
            setVisualControlAction('')
            break;
        case pVisualControl.Btn_Siguiente.id_action:
            if (activeStep < 2){
                setActiveStep(activeStep + 1);
                const lemma_id_step = dialogElements["elements"][activeStep+1]
                const gloss_id_step =  dialogElements["inference_glosses"][activeStep+1]
                handleClickStep(lemma_id_step, gloss_id_step)
                setVisualControlAction('')
            }else{
                setActiveStep(0);
                const lemma_id_step = dialogElements["elements"][0]
                const gloss_id_step =  dialogElements["inference_glosses"][0]
                handleClickStep(lemma_id_step, gloss_id_step)
                setVisualControlAction('')
            }
            break;
        case pVisualizerControl.Btn_OK.id_action:
        case pVisualControl.Btn_OK.id_action:
            handleClickClose();
            setVisualControlAction('')
            break;
        default:
            break;
    }
  }, [visualControlAction])

  // useEffect(() => {
  //   console.log("🚀 ~ file: SignDialog.js:251 ~ SignDialog ~ activeStep:", activeStep)
  // }, [activeStep])
  



  return (
    <Dialog className="sig_SignModal_Dialog" open={openDialog} onClose={handleClickClose} maxWidth="md" style={{left : moveLeftVisualControl}} BackdropProps={
      noCenterDialog ? {}
      :{
        style: {
          backdropFilter: "blur(3px)", // Estilo de fondo con desenfoque
          backgroundColor: "#5ea0d480",
          WebkitBackdropFilter: "blur(3px)",
        }
      }
    }>
      {loading ? (
        <LoadingDialog />
      ) : (
        <>
          <DialogHeader dialogPosition={dialogPosition} tabValue={tabValue} setTabValue={setTabValue} handleClose={handleClickClose} arr_history={arr_history} returnLastEntryHistory={returnLastEntryHistory} />
          <Paper data-tour="tourSign_3" square className="sig_SignModal_TabsPaper">
            <Tabs
              className="sig_SignModal_Tabs"
              value={tabValue}
              onChange={(event, newValue) => {
                setTabValue(newValue);
              }}
              indicatorColor="primary"
              textColor="primary"
              centered
            >
              <Tab className="sig_SignModal_Tab" label={t("sDialog.signTab")} />
              <Tab className="sig_SignModal_Tab" label={t("sDialog.defTab")} />
              <Tab className="sig_SignModal_Tab" label={t("sDialog.exampleTab")} />
            </Tabs>
          </Paper>

          <DialogContent className="sig_SignModal_DialogContent">
            {tabValue === pDialogTab.sign ? (
              <>
                 <DialogContentSign dialogElements={dialogElements} dialogPosition={dialogPosition} setDialogPosition={setDialogPosition} sendFeedback2Server={sendFeedback2Server} handlePushScreenCollaborator={handlePushScreenCollaborator} isAdmin={isAdmin} isTask={isTask}>
                  {dialogElements["elements"][1] !== undefined ? (
                    <>
                      {/* {predictionFS !== undefined && <Paper> LETRAS RECONOCIDAS: {predictionFS}</Paper>} */}
                      {predictionFS !== undefined &&
                      <Accordion expanded={expanded} onChange={handleChange}>
                        <AccordionSummary
                          expandIcon={<ExpandMoreIcon />}
                          aria-controls="panel1a-content"
                          id="panel1a-header"
                          sx={{ minHeight: '32px', '& .MuiAccordionSummary-content': { margin: '2px' } }}
                        >
                          Reconocimiento del deletreo. Información
                        </AccordionSummary>
                        <AccordionDetails>
                          <div><strong>Inferencia:</strong> {predictionFS['inference']}</div>
                          <hr></hr>
                          <div style={{ fontStyle: 'italic', fontSize: '0.9em', color: 'gray' }}>
                            <strong>Tiempo procesado vídeo:</strong> {predictionFS['video_processing_time'].toFixed(2)} seg
                          </div>
                          <div style={{ fontStyle: 'italic', fontSize: '0.9em', color: 'gray' }}>
                            <strong>Tiempo preajuste entrada al modelo:</strong> {predictionFS['input_adjust_time'].toFixed(2)} seg
                          </div>
                          <div style={{ fontStyle: 'italic', fontSize: '0.9em', color: 'gray' }}>
                            <strong>Tiempo de inferencia:</strong> {predictionFS['inference_time'].toFixed(2)} seg
                          </div>
                          <div>
                            <strong>Tiempo total:</strong> {predictionFS['total_time'].toFixed(2)} seg
                          </div>
                        </AccordionDetails>
                      </Accordion>
                      }




                      <DialogSignsStepper dialogElements={dialogElements} handleClickStep={handleClickStep} activeStep={activeStep} setActiveStep={setActiveStep} sendFeedback2Server={sendFeedback2Server} />
                    </>
                  ) : null}
                  <DialogContentMore dialogPosition={dialogPosition} handleClickChangeLemma={handleClickChangeLemma} handleClickChangeLemmaByGloss={handleClickChangeLemmaByGloss}/>

                  {sendFeedback2Server !== undefined && (tabValue === pDialogTab.sign || tabValue === pDialogTab.def || tabValue === pDialogTab.variants) ? (
                    <>
                      <DialogContent className="sig_SignDialog_ButtonFeedbackContainer">
                          <Button className="sig_SignDialog_Button sig_SignDialog_ButtonFeedback" endIcon={<SendIcon />} onClick={handleClickStartSendFeedback}>
                            {t("sDialog.startFeedback")}
                          </Button>
                      </DialogContent>
                    </>
                  ) : (
                    <></>
                  )}
                </DialogContentSign>
              </>
            ) : (
              <></>
            )}


            {tabValue === pDialogTab.def ? (
              <>
                 <DialogContentDef dialogPosition={dialogPosition} setDialogPosition={setDialogPosition} dialogElements={dialogElements}>
                  {dialogElements["elements"][1] !== undefined ? (
                    <>
                      <DialogSignsStepper dialogElements={dialogElements} handleClickStep={handleClickStep} activeStep={activeStep} setActiveStep={setActiveStep} sendFeedback2Server={sendFeedback2Server} />
                    </>
                  ) : null}
                  <DialogContentMore dialogPosition={dialogPosition} handleClickChangeLemma={handleClickChangeLemma} handleClickChangeLemmaByGloss={handleClickChangeLemmaByGloss}/>

                  {sendFeedback2Server !== undefined && (tabValue === pDialogTab.sign || tabValue === pDialogTab.def || tabValue === pDialogTab.variants) ? (
                    <>
                      <DialogContent className="sig_SignDialog_ButtonFeedbackContainer">
                        <Button className="sig_SignDialog_Button sig_SignDialog_ButtonFeedback" endIcon={<SendIcon />} onClick={handleClickStartSendFeedback}>
                          {t("sDialog.startFeedback")}
                        </Button>
                      </DialogContent>
                    </>
                  ) : (
                    <></>
                  )}
                </DialogContentDef>
              </>
            ) : (
              <></>
            )}

            {tabValue === pDialogTab.examples ? <DialogContentExamples dialogElements={dialogElements} dialogPosition={dialogPosition} setDialogPosition={setDialogPosition} handleClickChangeLemmaByGloss={handleClickChangeLemmaByGloss}/> : <></>}

            {tabValue === pDialogTab.none ? <DialogContentSelectManual handleClickManualSelectionLemmaManual={handleClickManualSelectionLemmaManual} /> : <></>}

            {tabValue === pDialogTab.feedback ? <DialogContentSendFeedback dialogPosition={dialogPosition} handleClickConfirmSendFeedback={handleClickConfirmSendFeedback} handleClickCancelSendFeedback={handleClickCancelSendFeedback} selectGlossFeedback={undefined} /> : <></>}
          
          </DialogContent>

          
        </>
      )}
    </Dialog>
  );
}
